module.exports = __webpack_public_path__ + "img/login.d9891841.svg";